// extracted by mini-css-extract-plugin
export default {"background":"app_background__rupZw","app":"app_app__sRM-7"};